export const WS_METHODS = {
  PLACE_MARKET_ORDER: "placeMarketOrder",
  PLACE_PENDING_ORDER: "placePendingOrder",
  UPDATE_OPERATION: "updateOperationV2",
  CLOSE_OPEN_POSITION: "closeOpenPosition",
  CANCEL_PENDING_ORDER: "cancelPendingOrder",
  LIST_ALL_OPERATIONS: "listAllOperations",
  INFO: "info",
  METRICS: "metrics",
  TIME_SERIES: "timeSeries",
} as const;

export const WS_EVENTS = {
  TOURNAMENT_EVENT: "TOURNAMENT_EVENT",
  PRICE_UPDATED: "PRICE_UPDATED",
} as const;

export const TOURNAMENT_EVENT_TYPES = {
  POSITION_OPENED: "POSITION_OPENED",
  POSITION_EDITED: "POSITION_EDITED",
  ORDER_PLACED: "ORDER_PLACED",
  ORDER_EDITED: "ORDER_EDITED",
  POSITION_CLOSED: "POSITION_CLOSED",
  ORDER_FAILED: "ORDER_FAILED",
  ORDER_CANCELLED: "ORDER_CANCELLED",
  TOURNAMENT_CLOSED: "TOURNAMENT_CLOSED",
} as const;
